
import VueApexCharts from "vue-apexcharts";
import { Component, Vue,Watch } from 'vue-property-decorator';
import axios from 'axios';
@Component({
  components: {
    apexchart: VueApexCharts,
  },
  data() {
  return {
    isVersionLoading: false,
    isGeoLoading: false,
    isDailyUserCountLoading: false,
    isMonthlyUserCountLoading: false,
  }
}
})
export default class Dashboards extends Vue {
  public dateFrom: Date | null = null;
  public dateTo: Date | null = null;
  public MonthdateFrom: Date | null = null;
  public MonthdateTo: Date | null = null;
  public PiedateFrom: Date | null = null;
  public PiedateTo: Date | null = null;
  public GeodateFrom: Date | null = null;
  public GeodateTo: Date | null = null;
  public bardateFrom: Date | null = null;
  public bardateTo: Date | null = null;
  public ErrordateFrom: Date | null = null;
  public ErrordateTo: Date | null = null;
  public isBusy = false;
  public pieChartSeries = []; // Example data representing different categories
  public pieChartOptions = {
    chart: {       
      type: 'pie',
      toolbar:{
      show:true,
      tools: {
              download: true, // Enable download options
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            }, 
            autoSelected: 'zoom',     
        export: {
              csv: {
                filename: 'pie-chart-data',
                columnDelimiter: ',',
                headerCategory: 'Slidefox Version',
                headerValue: 'Count',
              },
              svg: {
                filename: 'pie-chart',
              },
              png: {
                filename: 'pie-chart',
              },
            },      
    },
    },
    labels: [],    
    dataLabels: {
      enabled: true,
    },
    tooltip: {
      enabled: true,
    },
  };
  public GeoChartSeries = []; // Example data representing different categories
  public GeoChartOptions = {
    chart: {       
      type: 'donut',
      toolbar:{
      show:true,
      tools: {
              download: true, // Enable download options
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            }, 
            autoSelected: 'zoom',     
        export: {
              csv: {
                filename: 'pie-chart-data',
                columnDelimiter: ',',
                headerCategory: 'Country',
                headerValue: 'User',
              },
              svg: {
                filename: 'pie-chart',
              },
              png: {
                filename: 'pie-chart',
              },
            },      
    },
    },
    labels: [],    
    dataLabels: {
      enabled: true,
    },
    tooltip: {
      enabled: true,
    },
  };

  @Watch('dateFrom')
  public onDateFromChange(newVal: Date | null) {
    if (newVal) {      
      const newDate = new Date(newVal);
      newDate.setDate(newDate.getDate() + 29);
      this.dateTo = newDate;

      // Call loadDailyUserCount whenever dateFrom changes
      this.loadDailyUserCount();
    }
  }
  
  @Watch('PiedateFrom')
  public onPieDateFromChange(newVal: Date | null) {
    if (newVal) {      
      const newDate = new Date(newVal);
      newDate.setDate(newDate.getDate() + 1);
      this.PiedateTo = newDate;

      // Call loadDailyUserCount whenever dateFrom changes
      this.loadDailyUserAgentCount();
    }
  }
  @Watch('GeodateFrom')
  public onGeoDateFromChange(newVal: Date | null) {
    if (newVal) {      
      const newDate = new Date(newVal);
      newDate.setDate(newDate.getDate() + 1);
      this.GeodateTo = newDate;

      // Call loadDailyUserCount whenever dateFrom changes
      this.loadDailyGeoCount();
    }
  }
  
  @Watch('MonthdateFrom')
  public onMonthdateFromChange(newVal: Date | null) {
    if (newVal) {     
      const newDate = new Date(newVal);            
      this.MonthdateTo = this.getLastDateOfMonth(new Date(newDate.setMonth(newDate.getMonth() + 5)));
      // Call loadDailyUserCount whenever dateFrom changes
      this.loadMonthlyUserCount();
    }
  }
  
  public DailySeries = [
    {
      name: 'User Count',
      data: [],
    },
  ];
  public MonthlySeries = [
    {
      name: 'User Count',
      data: [],//[90, 160, 140, 190, 280, 210, 350, 300, 320, 310, 400, 500],
    },
  ];
  
public chartOptions = {
    chart: {
      height: '250px',      
      type: 'line',
      toolbar: {
            show: true, // Display the toolbar
            tools: {
              download: true, // Enable only the download button
              selection: false, // Disable selection tool
              zoom: false, // Disable zoom
              zoomin: false, // Disable zoom in
              zoomout: false, // Disable zoom out
              pan: false, // Disable pan
              reset: false, // Disable reset zoom
            },
          },
    },
    stroke: {
      width: 2,
      curve: 'smooth',
    },
    xaxis: {
      categories:[],// Array.from({ length: 31 }, (_, i) => i + 1),
      title: {
        text: 'Date', // X-axis label (horizontal)
      },
    },
    yaxis: {
      title: {
        text: 'User Count', // Y-axis label (vertical)
      },
    },
    title: {
      text: '',
      align: 'center',
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      enabled: true,
    },
  };
  
  public MonthlyChartOptions = {
    chart: {
      height: '250px',
      type: 'line',
      toolbar: {
            show: true, // Display the toolbar
            tools: {
              download: true, // Enable only the download button
              selection: false, // Disable selection tool
              zoom: false, // Disable zoom
              zoomin: false, // Disable zoom in
              zoomout: false, // Disable zoom out
              pan: false, // Disable pan
              reset: false, // Disable reset zoom
            },
          },
    },
    stroke: {
      width: 2,
      curve: 'smooth',
    },
    xaxis: {
      categories: [],
      title: {
        text: 'Month', // X-axis label (horizontal)
      },
    },
    yaxis: {
      title: {
        text: 'User Count', // Y-axis label (vertical)
      },
    },
    title: {
      text: '',
      align: 'center',
    },
    dataLabels: {
      enabled: true,
    },
    tooltip: {
      enabled: true,
    },
  };
  
  public mounted() {
    const today = new Date();
    const Lastmonthdate = new Date();
    const LastOneyearbackdate = new Date();
    Lastmonthdate.setDate(Lastmonthdate.getDate() - 29);
    LastOneyearbackdate.setMonth(LastOneyearbackdate.getMonth() - 5);
    this.dateFrom = this.formatDate(Lastmonthdate);

    const nextMonth = new Date(Lastmonthdate);
    nextMonth.setDate(Lastmonthdate.getDate() + 29);
    this.dateTo = nextMonth;
   
    this.PiedateFrom = this.formatDate(today);
    const nextday = new Date(today);
    nextday.setDate(today.getDate() + 1);
    this.PiedateTo = nextday;

  
    this.GeodateFrom = this.formatDate(today);
    const nextdayGeo = new Date(today);
    nextdayGeo.setDate(today.getDate() + 1);
    this.GeodateTo = nextdayGeo;

   
// Set start date to the first day of the current month
    this.MonthdateFrom = this.getFirstDateOfMonth(LastOneyearbackdate);

// Set end date to the last day of the month 12 months later
    this.MonthdateTo = this.getLastDateOfMonth(new Date(LastOneyearbackdate.setMonth(LastOneyearbackdate.getMonth() + 5)));

    //this.loadDailyUserCount();
   // this.loadMonthlyUserCount();
    //this.loadDailyUserAgentCount();    
    //this.loadDailyGeoCount();
  }
  public loadDailyUserCount(){
    if (!this.dateFrom || !this.dateTo) {
      return;
    }
    const fromDate = this.dateFrom;
    const toDate =this.formatDate(this.dateTo);
    this.isBusy = true;
    this.isDailyUserCountLoading = true;
    axios.get('/api/v4/Logs/dailyusercounts/'+ localStorage.hostMode +"/" +fromDate + "/" + toDate ).then(      
      (response: any) => {        
        const d = response.data[0] || [];
        const keysdata = Object.keys(d);       
        this.$set( this.DailySeries[0],'data',Object.values(d));
        const dayLabels = keysdata.map(date => {
      const d = new Date(date); // Convert string to Date object
      return d.getDate().toString(); // Extract day as string
    });
    this.$set(this.chartOptions.xaxis, 'categories',dayLabels);
    this.chartOptions = Object.assign({}, this.chartOptions);
    this.isBusy = false;
      },
      (error) => {
        console.error('Error loading user version data:', error);
        
      })
    .finally(() => {
      // Set loading state to false after request completes (success or error)
      this.isDailyUserCountLoading = false;
    });
    
    
  }
  
  
  public loadDailyUserAgentCount(){
    if (!this.PiedateFrom || !this.PiedateTo) {
      return;
    }
    const fromDate = this.PiedateFrom;
    const toDate =this.formatDate(this.PiedateTo);
    this.isBusy = true;
    this.isVersionLoading = true;
    axios.get('/api/v4/Logs/UsersbyVersion/'+ localStorage.hostMode +"/" +fromDate + "/" + toDate ).then(
      (response: any) => {                
        const d = response.data[0] || [];                    
        this.pieChartSeries =Object.values(d);
        this.pieChartOptions.labels =Object.keys(d);        
    this.pieChartOptions = Object.assign({}, this.pieChartOptions);
    this.isBusy = false;
      },
      (error) => {
        
        console.error('Error loading user version data:', error);
        
      })
    .finally(() => {
      // Set loading state to false after request completes (success or error)
      this.isVersionLoading = false;
    });
    
  }
  public loadDailyGeoCount(){
    if (!this.GeodateFrom || !this.GeodateTo) {
      return;
    }
    const fromDate = this.GeodateFrom;
    const toDate =this.formatDate(this.GeodateTo);
    this.isBusy = true;
    this.isGeoLoading = true;
    axios.get('/api/v4/Logs/UsersbyDemograpic/'+ localStorage.hostMode +"/" +fromDate + "/" + toDate ).then(
      (response: any) => {                
        const d = response.data[0] || [];                    
        this.GeoChartSeries =Object.values(d);
        this.GeoChartOptions.labels =Object.keys(d);       
    this.GeoChartOptions = Object.assign({}, this.GeoChartOptions);
    this.isBusy = false;
      },
      (error) => {
        this.isGeoLoading = false;
        console.error('Error loading user version data:', error);
        
      })
    .finally(() => {
      // Set loading state to false after request completes (success or error)
      this.isGeoLoading = false;
    });
    
  }
  
  public formatDate(date: Date | null): string | null {
  if (date instanceof Date && !isNaN(date.getTime())) {
    return date.toISOString().split('T')[0]; // Format as 'YYYY-MM-DD'
  }
  return null;
}
public getFirstDateOfMonth(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    return `${year}-${month}-01`; // Return in YYYY-MM-DD format
  }

  public getLastDateOfMonth(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const lastDay = new Date(year, date.getMonth() + 1, 0).getDate(); // Get the last day of the month
    return `${year}-${month}-${lastDay}`; // Return in YYYY-MM-DD format
  }
  public loadMonthlyUserCount(){
    this.isBusy = true;
    // Create a map for month names
    const monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];    
    const fromDate = this.MonthdateFrom;
    const toDate =this.MonthdateTo;
    this.isBusy = true;
    this.isMonthlyUserCountLoading = true;
    //axios.get('/api/v4/Logs/monthlyusers/2023-10-01/2024-09-30' )
    axios.get('/api/v4/Logs/monthlyusers/'+ localStorage.hostMode +"/" +fromDate + "/" + toDate ).then(         
      (response: any) => {        
        const d = response.data[0] || [];
        const keysdata = Object.keys(d);
        this.isBusy = false;
        this.MonthlySeries[0].data = Object.values(d);
        const monthLabels = keysdata.map(date => {
      const d = new Date(date); // Convert string to Date object
      return monthNames[d.getMonth()]; // Get month name from Date object
        });
        this.MonthlyChartOptions.xaxis.categories = monthLabels;
        this.MonthlyChartOptions = Object.assign({}, this.MonthlyChartOptions);
      },
      (error) => {
        this.isMonthlyUserCountLoading = false;
        console.error('Error loading user version data:', error);
        
      })
    .finally(() => {
      // Set loading state to false after request completes (success or error)
      this.isMonthlyUserCountLoading = false;
    });
    
  }
}
